import { useFireSessionContext } from '@chilipiper/fire-session'
import { useMyReviews } from '@/api/email-agent'

/**
 * Cheap probe: does the current user have any reviewable email drafts? Used to
 * gate the "Email Review" nav entry + route so users who aren't in any Email
 * Composer reviewer set never see the surface.
 */
export const useHasReviewableDrafts = (): boolean => {
  const { tenantId } = useFireSessionContext()
  const { queryData } = useMyReviews(tenantId)

  return (queryData.reviewQueue?.total ?? 0) > 0
}
